import { Box, Grid } from '@mui/material';
import { Button } from '../Button';
import COLORS from '../../colors';
import { MONTH_PASCAL } from '../../constants';

interface MonthNavigationProps {
  previousMonth: MONTH_PASCAL | null;
  nextMonth: MONTH_PASCAL | null;
  showNextPageNavigation: boolean;
  navigateForward: () => void;
  navigateBackward: () => void;
  navigateNext: () => void;
}

const MonthNavigation = ({
  previousMonth,
  nextMonth,
  showNextPageNavigation,
  navigateForward,
  navigateBackward,
  navigateNext
}: MonthNavigationProps) => {
  return (
    <Grid container justifyContent={'flex-end'}>
      {previousMonth && (
        <Box paddingRight={'10px'}>
          <Button
            label={`Back to ${previousMonth}`}
            backgroundColor={COLORS.NEUTRAL_900}
            hoverBackgroundColor={COLORS.BUTTON_SECONDARY_HOVER}
            textColor={COLORS.PRIMARY_500}
            onClick={navigateBackward}
          />
        </Box>
      )}
      {nextMonth && (
        <Box>
          <Button
            label={`Continue to ${nextMonth}`}
            backgroundColor={COLORS.PRIMARY_500}
            hoverBackgroundColor={COLORS.BUTTON_PRIMARY_HOVER}
            textColor={COLORS.PRIMARY_800}
            onClick={navigateForward}
          />
        </Box>
      )}
      {showNextPageNavigation && (
        <Box>
          <Button
            label={`Continue to next section`}
            backgroundColor={COLORS.PRIMARY_500}
            hoverBackgroundColor={COLORS.BUTTON_PRIMARY_HOVER}
            textColor={COLORS.PRIMARY_800}
            onClick={navigateNext}
          />
        </Box>
      )}
    </Grid>
  );
};

export default MonthNavigation;
